/** Legacy HTML media can cache responses without CORS headers or Vary: Origin.
 * Revalidate bytes while keeping the original URL, authentication policy and editor clocks.
 * Shared identity avoids restarting media effects on each timeline frame.
 */
export const sourceMediaRequest=Object.freeze({cache:'reload' as const});
